
import { AnimatePresence, motion} from "framer-motion";
import React, {useEffect} from "react";
import { FaAngleDown } from "react-icons/fa";
import { NavLink } from "react-router-dom";


const menuAnimation = {
  hidden: {
    opacity: 0,
    height: 0,
    padding: 0,
    transition: { duration: 0.3, when: "afterChildren" },
  },
  show: {
    opacity: 1,
    height: "auto",
    transition: {
      duration: 0.3,
      when: "beforeChildren",
    },
  },
};
const menuItemAnimation = {
  hidden: (i) => ({
    padding: 0,
    x: "-100%",
    transition: {
      duration: (i + 1) * 0.1,
    },
  }),
  show: (i) => ({
    x: 0,
    transition: {
      duration: (i + 1) * 0.1,
    },
  }),
};

const SidebarMenu = ({
  route,
  showAnimation,
  isOpen,
  setIsOpen,
  key,
  isMenuOpen,
  setIsMenuOpen,
  permissionList,
}) => {
  const [activeSubRoute, setActiveSubRoute] = React.useState("");

  const toggleMenu = (e, id) => {
    if (isMenuOpen === id) {
      setIsMenuOpen("");
    } else {
      setIsMenuOpen(id);
    }

    setIsOpen(true);
  };

  const toggleSubRoute = (subRouteId) => {
    if (activeSubRoute === subRouteId) {
      setActiveSubRoute(""); // Close child routes for the active subroute
    } else {
      setActiveSubRoute(subRouteId); // Open child routes for the clicked subroute
    }
  };

  const getRole = sessionStorage.getItem("token");
  const role = JSON.parse(getRole).authorities;


  return (
    <>
      {/* Parent Menu */}
      <div
        key={key}
        className={`menu submenu ${!isOpen && "center"} ${
          isMenuOpen === route.id ? "submenu-active" : ""
        }`}
        onClick={(e) => toggleMenu(e, route.id)}
      >
        <div className="menu_item">
          <div className="icon pointer">{route.icon}</div>
          <AnimatePresence>
            {isOpen && (
              <motion.div
                variants={showAnimation}
                initial="hidden"
                animate="show"
                exit="hidden"
                className="link_text"
              >
                {route.name}
              </motion.div>
            )}
          </AnimatePresence>
        </div>
        {isOpen && (
          <motion.div
            className="pointer"
            animate={
              isMenuOpen
                ? {
                    rotate: 0,
                  }
                : { rotate: -90 }
            }
          >
            <FaAngleDown />
          </motion.div>
        )}
      </div>

      {/* SubMenu */}
      <AnimatePresence>
        {isMenuOpen === route.id && (
          <motion.div
            variants={menuAnimation}
            initial="hidden"
            animate="show"
            exit="hidden"
            className={`menu_container ${
              isMenuOpen ? "menu_container_active" : ""
            }`}
          >
            {route.subRoutes.map((subRoute, i) => (
              <>
                {(permissionList.includes(subRoute.Permissions) ||
                  subRoute?.role.includes(role)) && (
                  <motion.div
                    variants={menuItemAnimation}
                    key={i}
                    custom={i}
                    className={`subRoute-item ${
                      subRoute.childRoutes && subRoute.childRoutes.length > 0
                        ? "has-children"
                        : ""
                    }`}
                  >
                    {/* Conditional Render for Motion Div or NavLink */}
                    {subRoute.childRoutes &&
                    subRoute.childRoutes.length > 0 ? (
                      // Item with Child Routes
                      <div
                      className={`menu_item ${
                        subRoute.childRoutes && subRoute.childRoutes.length > 0
                          ? "menu submenu"
                          : ""
                      }`}
                        onClick={() => toggleSubRoute(subRoute.path)}
                      >
                        <div className="flex menu_item ">
                        <div className="icon">{subRoute.icon}</div>
                        <motion.div className="link_text">
                          {subRoute.name}
                        </motion.div>
                       
                        </div>
                      
                       
                        <motion.div
                          className={`arrow-icon ${
                            activeSubRoute === subRoute.path
                              ? "arrow-active"
                              : ""
                          }`}
                          animate={
                            activeSubRoute === subRoute.path
                              ? { rotate: 0 }
                              : { rotate: -90 }
                          }
                        >
                          
                          <FaAngleDown />
                        </motion.div>
                      </div>
                    ) : (
                      // Item without Child Routes
                      <NavLink
                        to={subRoute.path}
                        className="link"
                        title={subRoute.name}
                      >
                        <div className="icon">{subRoute.icon}</div>
                        <motion.div className="link_text">
                          {subRoute.name}
                        </motion.div>
                      </NavLink>
                    )}

                    {/* Child Routes */}
                    {activeSubRoute === subRoute.path &&
                      subRoute.childRoutes &&
                      subRoute.childRoutes.length > 0 && (
                        <motion.div
                          variants={menuAnimation}
                          initial="hidden"
                          animate="show"
                          exit="hidden"
                          className="child-menu-container"
                        >
                          {subRoute.childRoutes.map((childRoute, j) => (
                            <div
                              key={`${i}-${j}`}
                              className={`childRoute-item ${
                                permissionList.includes(childRoute.Permissions) ||
                                childRoute?.role === role
                                  ? "visible"
                                  : "hidden"
                              }`}
                            >
                              <NavLink
                                to={childRoute.path}
                                className="link"
                                title={childRoute.name}
                              >
                                <div className="icon">{childRoute.icon}</div>
                                <div className="link_text">
                                  {childRoute.name}
                                </div>
                              </NavLink>
                            </div>
                          ))}
                        </motion.div>
                      )}
                  </motion.div>
                )}
              </>
            ))}
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default SidebarMenu;




